// extracted by mini-css-extract-plugin
module.exports = {"link":"articles-cards-list_link__iBybV","listItem":"articles-cards-list_listItem__r9M6a"};